<template>
    <div>
        <div class="title__container">
            <b>{{ question }}</b>
        </div>
        <ValidationProvider
            v-slot="{ errors }"
            rules="required"
        >
            <CustomTextArea
                v-model="model.answer"
                :disabled="disabled"
                placeholder="Comentario"
                :rows="2"
                :maxlength="3000"
                class="my-4"
                :error="errors[0]"
                custom-error-msg="Comentario es requerido"
            />
        </ValidationProvider>
    </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import { ValidationProvider } from "vee-validate";

export default {  
    name: "SchoolIntegrationQuestion",
    components: {
        CustomTextArea,
        ValidationProvider
    },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({
                answer: "",
                comment: "",
            }),
        },
        question: {
            type: String,
            required: true,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data: () => ({
        model: {
            answer: "",
            comment: "",
        },
    }),
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.model.answer = newValue.answer;
                this.model.comment = newValue.comment;
            }
        },
        model: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        },
    },
};
</script>

<style scoped>
.title__container {
    padding-top: 30px;
}

::v-deep textarea:disabled {
    cursor: not-allowed !important;
}
</style>
  